function CategoryHeader({ color, icon, title, description }) {
  return (
    <div className="categoryHeader">
      <span
        className="categoryHeaderBar"
        style={{
          backgroundColor: `${color}`,
        }}
      ></span>
      <div className="categoryHeaderLeft">
        <span
          style={{
            backgroundColor: `${color}`,
          }}
        ></span>
        <img src={`${process.env.PUBLIC_URL}/assets/svg/${icon}`} alt={title} />
      </div>
      <div className="categoryHeaderRight">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default CategoryHeader;
